// extracted by mini-css-extract-plugin
export var componentModuleLeftToRightBtnVE65d = "component-module--component-module--leftToRightBtn--VE65d--d30ab";
export var formAsideMobile = "component-module--formAsideMobile--0e568";
export var formButtons = "component-module--formButtons--89967";
export var formButtonsWrapper = "component-module--formButtonsWrapper--e6e23";
export var formContent = "component-module--formContent--e5533";
export var formLogo = "component-module--formLogo--e2f30";
export var formLogoBlock = "component-module--formLogoBlock--7a415";
export var formPage = "component-module--formPage--e92bb";
export var formSubmit = "component-module--formSubmit--4afbf";
export var formWrapper = "component-module--formWrapper--03e8e";